<template>
  <div class="form">
    <div class="row" v-if="header.length > 0">
      <div class="col-12 head" v-html="header"></div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CustomForm',
  props: {
    header: {
      type: String,
      default: '',
    },
  },
  methods: {
    toStep1() {
      this.$parent.$parent.store.currentRoute = 'step1'
    }
  }
};
</script>

<style scoped>
.form {
  background-color: #dadada;
  border-radius: 10px;
  padding: 15px 30px;
}

.head {
  font-size: 1.5rem;
  font-weight: 600;
  color: #472483;
  text-align: center;
  margin-bottom: 40px;
}

.back-arrow {
  position: absolute;
  cursor: pointer;
}
</style>
